import React from 'react';
import {View, StyleSheet, TouchableOpacity} from 'react-native';
import {Text} from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import {useTranslation} from 'react-i18next';
import {onboardingColors} from '../../theme/onboardingColors';

const WelcomeScreen = ({navigation}) => {
  const {t} = useTranslation();

  return (
    <View style={styles.container}>
      <View style={styles.brandSection}>
        <Icon name="content-cut" size={64} color={onboardingColors.primary} />
        <Text variant="headlineLarge" style={styles.title}>
          {t('onboarding.appName')}
        </Text>
        <Text variant="bodyMedium" style={styles.tagline}>
          {t('onboarding.tagline')}
        </Text>
      </View>

      <View style={styles.buttonSection}>
        <TouchableOpacity
          style={styles.loginButton}
          onPress={() => navigation.navigate('Login')}>
          <Text style={styles.loginButtonText}>{t('onboarding.login')}</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.createAccountButton}
          onPress={() => navigation.navigate('RegisterStep1')}>
          <Text style={styles.createAccountButtonText}>
            {t('onboarding.createAccount')}
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: onboardingColors.background,
  },
  brandSection: {
    flex: 0.6,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontWeight: 'bold',
    color: onboardingColors.primary,
    marginTop: 12,
  },
  tagline: {
    color: onboardingColors.textSecondary,
    marginTop: 4,
  },
  buttonSection: {
    flex: 0.4,
    justifyContent: 'center',
    paddingHorizontal: 32,
  },
  loginButton: {
    borderWidth: 2,
    borderColor: onboardingColors.primary,
    borderRadius: 28,
    paddingVertical: 14,
    alignItems: 'center',
    marginBottom: 16,
  },
  loginButtonText: {
    color: onboardingColors.primary,
    fontSize: 16,
    fontWeight: '600',
  },
  createAccountButton: {
    backgroundColor: onboardingColors.primary,
    borderRadius: 28,
    paddingVertical: 14,
    alignItems: 'center',
  },
  createAccountButtonText: {
    color: onboardingColors.white,
    fontSize: 16,
    fontWeight: '600',
  },
});

export default WelcomeScreen;
